import React from "react";

import { StoryCard } from "../basic/story-card.js";
import { CollectionName } from "../atoms/collection-name/index.js";
import { AdService } from "../ad-service";
import { wrapCollectionLayout } from "@quintype/components";
import PropTypes from "prop-types";
import { isEager, getRowMetadata } from "../../utils";

import "./two-col.m.css";

function TwoColBase({ collection, stories, config, associatedMetadata, index }) {
  const storyCardConfig = {
    subheadline: true,
    image: true,
    imageWidth: [400, 560]
  };
  const imageConfig = {
    image: true,
    imageAspectRatio: [16, 9],
    imageWidth: [200, 300]
  };
  const pbAheadConfig = getRowMetadata(config, associatedMetadata);
  const { show_collection_title: collectionName = true } = pbAheadConfig;
  return (
    <div styleName="component-wrapper" data-test-id="two-col-component">
      {collectionName ? <CollectionName name={collection.name} config={config} section={collection} /> : null}
      <div styleName="two-col__items">
        {stories.slice(0, 3).map(story => {
          return (
            <StoryCard
              eager={isEager(index, true)}
              key={story.id}
              story={story}
              config={imageConfig}
              hideSectionName={true}
            />
          );
        })}
        <div styleName="full-height-card">
          <StoryCard eager={isEager(index)} story={stories[3]} config={storyCardConfig} hideSectionName={true} />
        </div>
      </div>

      <div className="app-ad app-ad--horizontal">
        <AdService
          adtype="Horizontal-Ad"
          layoutName="TwoCol"
          collectionSlug={collection.slug}
          slotId={`TwoCol-${index}`}
        />
      </div>
    </div>
  );
}

TwoColBase.propTypes = {
  stories: PropTypes.arrayOf(PropTypes.object),
  config: PropTypes.object,
  collection: PropTypes.object,
  associatedMetadata: PropTypes.object,
  index: PropTypes.number
};

export const TwoCol = wrapCollectionLayout(TwoColBase);
